import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'

export const OuterWrapper = styled(Box)(`
    padding-top:10px;

    & .innerWrapper {
        display: flex;
        justify-content: space-between;
    }
    & .innerWrapper > div {
        width: calc(100% - 70px);
    }
    & .innerWrapper > * {
        min-width: auto;
        width: 50px;
        height: 35px;
        font-size:30px;
        padding: 0;
        margin: 0;
    }
`)
